import { useEffect, useRef, useState } from 'react'

import { getGretaAIChatTurnStartedAt } from './useGretaAIChatTurnStartedAt.utils'

export function useGretaAIChatTurnStartedAt({ activeChatId, isThinking }) {
  const turnStartedAtRef = useRef(new Map())
  const [turnStartedAt, setTurnStartedAt] = useState(null)

  // Refs aren't render-safe, so mirror the stored turn start into state here.
  useEffect(() => {
    setTurnStartedAt(
      getGretaAIChatTurnStartedAt(
        isThinking,
        turnStartedAtRef.current.get(activeChatId)
      )
    )
  }, [activeChatId, isThinking])

  function startTurn(conversationId) {
    turnStartedAtRef.current.set(conversationId, Date.now())
  }

  function preserveOrStartTurn(conversationId) {
    if (!turnStartedAtRef.current.has(conversationId)) {
      startTurn(conversationId)
    }
  }

  function clearTurn(conversationId) {
    turnStartedAtRef.current.delete(conversationId)
  }

  return { clearTurn, preserveOrStartTurn, startTurn, turnStartedAt }
}
